<template>
  <v-container>
    <div id="principaisClientes">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  style="text-align: left; width: 45px;"
                />
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('areaOrdenacao')"
                >
                  Área Comercial
                  <v-icon small>
                    {{ ordenarDados === 'areaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('ativosOrdenacao')"
                >
                  Clientes Ativos
                  <v-icon small>
                    {{ ordenarDados === 'ativosOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('coberturaOrdenacao')"
                >
                  Cobertura
                  <v-icon small>
                    {{ ordenarDados === 'coberturaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('porcentagemCoberturaOrdenacao')"
                >
                  % Cobertura
                  <v-icon small>
                    {{ ordenarDados === 'porcentagemCoberturaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('semCompraOrdenacao')"
                >
                  Sem Compra
                  <v-icon small>
                    {{ ordenarDados === 'semCompraOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('porcentagemSemCompraOrdenacao')"
                >
                  % Sem Compra
                  <v-icon small>
                    {{ ordenarDados === 'porcentagemSemCompraOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('ticketOrdenacao')"
                >
                  Ticket Médio
                  <v-icon small>
                    {{ ordenarDados === 'ticketOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('faturamentoOrdenacao')"
                >
                  Faturamento
                  <v-icon small>
                    {{ ordenarDados === 'faturamentoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('volumeOrdenacao')"
                >
                  Volumetria
                  <v-icon small>
                    {{ ordenarDados === 'volumeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('skuOrdenacao')"
                >
                  Cobertura SKU
                  <v-icon small>
                    {{ ordenarDados === 'skuOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('habitantesOrdenacao')"
                >
                  Nro Habitantes
                  <v-icon small>
                    {{ ordenarDados === 'habitantesOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in faturamentoPrincipaisClientes"
              :key="item.id_area"
            >
              <tr>
                <td style="text-align: center;">
                  <button @click="toggleExpand(index)">
                    {{ expanded.includes(index) ? '▲' : '▼' }}
                  </button>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.area }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.ativos }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.cobertura }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.porcentagemCobertura }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.semCompra }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.porcentagemSemCompra }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.ticket }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.volume }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.sku }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.habitantes }}
                </td>
              </tr>
              <tr
                v-if="expanded.includes(index)"
                :key="'expanded-' + item.id_area"
              >
                <td colspan="12">
                  <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                    <thead>
                      <tr>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('cidadeOrdenacao', index)"
                        >
                          Cidades
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'cidadeOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('ativosOrdenacao', index)"
                        >
                          Clientes Ativos
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'ativosOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('coberturaOrdenacao', index)"
                        >
                          Cobertura
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'coberturaOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('porcentagemCoberturaOrdenacao', index)"
                        >
                          % Cobertura
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'porcentagemCoberturaOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('semCompraOrdenacao', index)"
                        >
                          Sem Compra
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'semCompraOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('porcentagemSemCompraOrdenacao', index)"
                        >
                          % Sem Compra
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'porcentagemSemCompraOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('ticketOrdenacao', index)"
                        >
                          Ticket Médio
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'ticketOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('faturamentoOrdenacao', index)"
                        >
                          Faturamento
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'faturamentoOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('volumeOrdenacao', index)"
                        >
                          Volumetria
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'volumeOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('skuOrdenacao', index)"
                        >
                          Cobertura SKU
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'skuOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                          @click="mudarOrdenacaoDetalhe('habitantesOrdenacao', index)"
                        >
                          Nro Habitantes
                          <v-icon small>
                            {{ ordenarDadosDetalhe === 'habitantesOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                          </v-icon>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="sub in item.cidades"
                        :key="sub.id"
                      >
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ sub.cidade }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.ativos }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.cobertura }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.porcentagemCobertura }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.semCompra }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.porcentagemSemCompra }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.ticket }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.faturamento }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.volume }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.sku }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.habitantes }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Cliente from '../../../../../services/somentecliente4'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      vendedor: [],
      area: [],
      rede: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      linhaProducao: [],
      cidades: [],
      expanded: [],
      enableFatPrinCliente: false,
      faturamentoPrincipaisClientes: [],
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
      ordenarDadosDetalhe: '',
      ordenacaoDadosDetalheDecrescente: false,
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.vendedor = vendedor
        this.area = area
        this.rede = rede
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao
        this.cidades = cidades

        localStorage.setItem('supervisor', JSON.stringify(this.supervisor))
        localStorage.setItem('vendedor', JSON.stringify(this.vendedor))
        localStorage.setItem('area', JSON.stringify(this.area))
        localStorage.setItem('rede', JSON.stringify(this.rede))

        const empresaJson = JSON.stringify(this.select)
        localStorage.setItem('empresaId', empresaJson)

        this.showFaturamentoPrincipaisClientes()
      },

      async showFaturamentoPrincipaisClientes () {
        this.loading = true

        this.ordenarDados = ''
        this.ordenacaoDadosDecrescente = false
        this.ordenarDadosDetalhe = ''
        this.ordenacaoDadosDetalheDecrescente = false

        this.faturamentoPrincipaisClientes = []
        this.expanded = []

        await Cliente.showFatClientesCidades(this.primeiroDia, this.date, this.select, this.supervisor, this.area, this.rede, this.vendedor, this.receita, localStorage.tokencontrato, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhaProducao, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoPrincipaisClientes = resposta.data.dados.map((item) => {
              var listaFaturamento = ({
                id_area: item.id_area,
                area: item.area,
                areaOrdenacao: this.normalizaTexto(item.area),
                ativos: item.clientesAtivos.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                cobertura: item.cobertura.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                porcentagemCobertura: item.porcentagemCobertura.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                semCompra: item.semCompra.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                porcentagemSemCompra: item.porcentagemsemCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                ticket: item.ticket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                volume: item.volume.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                sku: item.sku.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                habitantes: item.habitantes.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                cidades: this.dadosCidades(item.cidades),
                ativosOrdenacao: item.clientesAtivos,
                coberturaOrdenacao: item.cobertura,
                porcentagemCoberturaOrdenacao: item.porcentagemCobertura,
                semCompraOrdenacao: item.semCompra,
                porcentagemSemCompraOrdenacao: item.porcentagemsemCompra,
                ticketOrdenacao: item.ticket,
                faturamentoOrdenacao: parseFloat(item.faturamento),
                volumeOrdenacao: item.volume,
                skuOrdenacao: item.sku,
                habitantesOrdenacao: item.habitantes,
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoPrincipaisClientes = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      dadosCidades (dados) {
        const dadosCidades = dados.map((item) => {
          var listaFaturamento = ({
            id: item.id,
            cidade: item.cidadeExibicao,
            cidadeOrdenacao: this.normalizaTexto(item.cidadeExibicao),
            ativos: item.clientesAtivos.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
            cobertura: item.cobertura.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
            porcentagemCobertura: item.porcentagemCobertura.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            semCompra: item.semCompra.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
            porcentagemSemCompra: item.porcentagemsemCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            ticket: item.ticket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            volume: item.volume.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            sku: item.sku.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
            habitantes: item.habitantes.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
            ativosOrdenacao: item.clientesAtivos,
            coberturaOrdenacao: item.cobertura,
            porcentagemCoberturaOrdenacao: item.porcentagemCobertura,
            semCompraOrdenacao: item.semCompra,
            porcentagemSemCompraOrdenacao: item.porcentagemsemCompra,
            ticketOrdenacao: item.ticket,
            faturamentoOrdenacao: parseFloat(item.faturamento),
            volumeOrdenacao: item.volume,
            skuOrdenacao: item.sku,
            habitantesOrdenacao: item.habitantes,
          })

          return listaFaturamento
        })

        return dadosCidades
      },

      normalizaTexto (texto) {
        return texto?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Z0-9\s]/gi, '').toUpperCase().trim()
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        const novaOrdenacao = [...this.faturamentoPrincipaisClientes]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDados] < b[this.ordenarDados]) result = -1
          if (a[this.ordenarDados] > b[this.ordenarDados]) result = 1

          if (this.ordenacaoDadosDecrescente) result *= -1

          return result
        })

        this.faturamentoPrincipaisClientes = novaOrdenacao
      },

      mudarOrdenacaoDetalhe (campo, index) {
        if (campo === this.ordenarDadosDetalhe) {
          this.ordenacaoDadosDetalheDecrescente = !this.ordenacaoDadosDetalheDecrescente
        } else {
          this.ordenarDadosDetalhe = campo
          this.ordenacaoDadosDetalheDecrescente = false
        }

        this.ordenarDadosTabelaDetalhe(index)
      },

      ordenarDadosTabelaDetalhe (index) {
        const novaOrdenacao = [...this.faturamentoPrincipaisClientes[index].cidades]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDadosDetalhe] < b[this.ordenarDadosDetalhe]) result = -1
          if (a[this.ordenarDadosDetalhe] > b[this.ordenarDadosDetalhe]) result = 1

          if (this.ordenacaoDadosDetalheDecrescente) result *= -1

          return result
        })

        this.faturamentoPrincipaisClientes[index].cidades = novaOrdenacao
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersPrincipaisClientes {
      font-size: 10px;
      max-width: 100%;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #principaisClientes {
      width: 100%;
    }

    #headersPrincipaisClientes {
      font-size: 10px;
    }
  }
</style>
